import { AsyncValidatorFn, AbstractControl } from '@angular/forms';

export class PeriodValidator {
    static isValidPeriod(): AsyncValidatorFn | null {
        const validator: AsyncValidatorFn | null = async (control: AbstractControl) => {
            if (!isNaN(Date.parse(control.get('period.start').value)) && !isNaN(Date.parse(control.get('period.end').value))) {
                const start = new Date(control.get('period.start').value).getTime();
                const end = new Date(control.get('period.end').value).getTime();

                return start < end ? null : { invalidPeriod: true };
            }
            return { invalidPeriod: true };
        };
        return validator;
    }
}
